var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 800 480",
    enableBackground: "new 0 0 800 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9A59CF",
    opacity: 1,
    stroke: "none",
    d: " M801.000000,241.000000  C801.000000,281.020905 801.000000,321.041779 800.624023,361.273926  C796.861023,361.323486 793.473999,361.020386 790.087036,361.020111  C527.058044,360.998138 264.029022,361.000000 1.000000,361.000000  C1.000000,321.312439 1.000000,281.624878 1.463884,241.468658  C268.285187,241.000000 534.642578,241.000000 801.000000,241.000000  z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF433",
    opacity: 1,
    stroke: "none",
    d: " M1.000000,121.000000  C1.000000,81.016708 1.000000,41.033417 1.000002,1.053937  C267.666687,1.057749 534.333313,1.057749 801.000000,1.057749  C801.000000,40.765675 801.000000,80.415855 800.536133,120.533020  C533.714844,121.000000 267.357422,121.000000 1.000000,121.000000  z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    opacity: 1,
    stroke: "none",
    d: " M1.000000,121.463882  C267.357422,121.000000 533.714844,121.000000 800.536133,121.000000  C801.000000,160.690750 801.000000,200.381485 801.000000,240.536118  C534.642578,241.000000 268.285187,241.000000 1.463884,241.000000  C1.000000,201.309250 1.000000,161.618515 1.000000,121.463882  z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    opacity: 1,
    stroke: "none",
    d: " M1.000000,361.463867  C264.029022,361.000000 527.058044,360.998138 790.087036,361.020111  C793.473999,361.020386 796.861023,361.323486 800.624023,361.742615  C801.000000,401.650330 801.000000,441.300659 801.000000,480.945190  C534.333313,480.939362 267.666656,480.939362 1.000000,480.939362  C1.000000,441.228394 1.000000,401.578094 1.000000,361.463867  z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbIcon);
export default __webpack_public_path__ + "static/media/nb-icon.e544a244aa68b8a6251be9cecde6d141.svg";
export { ForwardRef as ReactComponent };